import { render, staticRenderFns } from "./DeliveryFileUploader.vue?vue&type=template&id=da81d246&"
import script from "./DeliveryFileUploader.vue?vue&type=script&lang=js&"
export * from "./DeliveryFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFileUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports